import {AdvancedMarker, Map, Pin} from "@vis.gl/react-google-maps";
import React, {FC} from "react";

interface ISupplierSearchMapProps {
  markers: Array<{ position: google.maps.LatLngLiteral }>;
}

const SupplierSearchMap: FC<ISupplierSearchMapProps> = (props) => {
  return <Map
    mapId={"DEMO_MAP_ID"}
    defaultCenter={props.markers[0]?.position}
    center={props.markers[0]?.position || undefined}
    defaultZoom={12}
    maxZoom={15}
    minZoom={10}
    fullscreenControl={false}
    mapTypeControl={false}
    streetViewControl={false}
    zoomControl={true}
    clickableIcons={false}
  >
    {
      props.markers.map((marker, index) => (
        <AdvancedMarker key={index} position={marker.position}>
          <Pin/>
        </AdvancedMarker>
      ))
    }
  </Map>
};

export default SupplierSearchMap;